// Função para formatar valor como moeda brasileira
export const formatarValorReal = (value) => {
  if (!value || value === null || value === undefined) {
    return { formatted: "0,00", numeric: 0 };
  }

  try {
      const numericValue =
      parseFloat(value.toString().replace(/[^\d]/g, "")) / 100;
    const formatted = numericValue.toLocaleString("pt-BR", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

    return { formatted, numeric: numericValue };
  } catch (error) {
    console.error("Erro na formatação de valor:", error);
    return { formatted: "0,00", numeric: 0 };
  }
};

export const formatarPorcentagem = (value) => {
  if (!value || value === null || value === undefined) {
    return { formatted: "0,0", numeric: 0 };
  }

  try {
    const numericValue =
      parseFloat(value.toString().replace(/[^\d]/g, "")) / 10;
    const formatted = numericValue.toLocaleString("pt-BR", {
      minimumFractionDigits: 1,
      maximumFractionDigits: 1,
    });

    return { formatted, numeric: numericValue };
  } catch (error) {
    console.error("Erro na formatação de porcentagem:", error);
    return { formatted: "0,0", numeric: 0 };
  }
};

// Função para formatar moeda com símbolo R$
export const formatCurrencyMoeda = (value) => {
  return new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL",
  }).format(value || 0);
};

export const formatCurrencyPorcentagem = (value) => {
  return new Intl.NumberFormat("pt-BR", {
    style: "percent",
    minimumFractionDigits: 1,
  }).format(value / 100);
};
